import { Injectable } from '@angular/core';
import { IrbAppEvents } from '@irb/app.events';
import { AppService } from '@irb/app.service';
 import { IrbAgGridExportService } from '@irb/irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service';
 import { IExportRequest, IValidateThinkPipeExport } from '@irb/irb-orders/irb-orders.model';
import { InventoryComponent } from './inventory.component';
 import { InventoryService } from './inventory.service';
 
 @Injectable({
   providedIn: 'root'
 })
 export class ExportInfoService {
 
   constructor(public ges: IrbAgGridExportService,
    private readonly pfs: InventoryService,
    private as: AppService){ }
     

exportDetails(parentObj:InventoryComponent,action:string,currentTab:string,isSelectAll:boolean,
   deselectedObj:any [],selectedObj:any[]){
    switch(action)	{
     case 'orders':
        return this.exportOrders(currentTab,isSelectAll,deselectedObj,selectedObj);
     case 'allocations':        
        return this.exportAllocations(currentTab,isSelectAll,deselectedObj,selectedObj);
     case 'blockAllocations': 
        return this.exportBlockAllocations(parentObj,currentTab,isSelectAll,deselectedObj,selectedObj);
     case 'thinkPipe': 
        return this.exportThinkPipeFormatValidation(parentObj,currentTab,isSelectAll,deselectedObj,selectedObj);  
    }    

}

  exportOrders(currentTab:string,isSelectAll:boolean,deselectedObj:any [],selectedObj:any[]){
   const request = {} as IExportRequest;
   request.currentTab = currentTab;
   request.selectedIds = [];
   request.deselectedIds = [];
      if (isSelectAll || selectedObj.length === 0) {
         request.isSelectAll = true;
         deselectedObj.forEach((node: any) => {
             request.deselectedIds.push(node.orderID);
         });
     } else {  
             request.isSelectAll = false;
         for (let i = 0; i < selectedObj.length; i++) {
             request.selectedIds.push(selectedObj[i].orderID);
          }
     }
     this.pfs.exportOrders(request).subscribe((_res: any) => {
         this.ges.showSuccessMessage();
     }, () => {});
  }
 
 exportAllocations(currentTab:string,isSelectAll:boolean,deselectedObj:any [],selectedObj:any[]){
   const request = {} as IExportRequest;
   request.currentTab = currentTab;
   request.selectedIds = [];
   request.deselectedIds = [];
   if (isSelectAll) {
      request.isSelectAll = true;
      deselectedObj.forEach((node: any) => {
          request.deselectedIds.push(node.orderID);
      });
  } else {  
          request.isSelectAll = false;
      for (let i = 0; i < selectedObj.length; i++) {
          request.selectedIds.push(selectedObj[i].orderID);
       }
  }
     this.pfs.exportAllocations(request).subscribe((_res: any) => {
         this.ges.showSuccessMessage();
     }, () => {});
 }
      
exportBlockAllocations(parentObj:InventoryComponent,currentTab:string,isSelectAll:boolean,deselectedObj:any [],selectedObj:any[]){   
   let isBlockOrder = false;
   const request = {} as IExportRequest;
   request.selectedIds = [];
   request.deselectedIds = [];
   request.currentTab = currentTab;
   if (isSelectAll) {
      request.isSelectAll = true;
      deselectedObj.forEach((node: any) => {
          request.deselectedIds.push(node.orderID);
      });
  } else {  
          request.isSelectAll = false;
      for (let i = 0; i < selectedObj.length; i++) {
         if(selectedObj[i].isBlockOrder != null){
            request.selectedIds.push(selectedObj[i].orderID);
         }
       }
  } 
     
  if( request.selectedIds != undefined  && request.selectedIds.length >0 || isSelectAll){
     this.pfs.exportBlockAllocations(request).subscribe((_res: any) => {
      this.ges.showSuccessMessage();
     },() => {});
   }else{
      parentObj.exportBlockAllocationDialog();
   }
 }
      
exportThinkPipeFormatValidation(parentObj:InventoryComponent,currentTab:string,isSelectAll:boolean,deselectedObj:any [],selectedObj:any[]){   
   const request = {} as IExportRequest;
   request.selectedIds = [];
   request.deselectedIds = [];
   request.currentTab = currentTab;

   
   if (isSelectAll) {
      request.isSelectAll = true;
      deselectedObj.forEach((node: any) => {
          request.deselectedIds.push(node.orderID);
      });
  } else {  
          request.isSelectAll = false;
      for (let i = 0; i < selectedObj.length; i++) {
          request.selectedIds.push(selectedObj[i].orderID);
       }
  }    
     this.validateData(parentObj,request);  
 }

 validateData(parentObj:InventoryComponent,request:IExportRequest){
   this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
   this.pfs.validateExportOrdersForThinkPipesFormat(request).subscribe((res: IValidateThinkPipeExport) => {
     
      if(res != null){
         this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
     
        if(res.notHeldCnt>0 || res.mutualFundSecTypeCnt){
         parentObj.validateThinkPipeDialog(request,res);
        }  else{
         this.exportThinkPipeFormat(request);
        }     
      }
     });
    
 }

 exportThinkPipeFormat(request:IExportRequest){
   this.pfs.exportThinkPipe(request).subscribe((_res: any) => {
      this.ges.showSuccessMessage();
   }, () => {});
 }
}
